(function() {
  'use strict';

  angular.module('eclipseApp.checkout').controller('buyFulfillmentCtrl', [
    '$scope',
    '$state',
    '$filter',
    'fulfillmentOptions',
    '$timeout',
    '$rootScope',
    'uteModal',
    'buyService',
    'notifier',
    'buyUtils',
    'dtmService',
    'dtmServiceConstants',
    'cartManager',
    'commonService',
    'brtSwitchCMS',
    function(
      $scope,
      $state,
      $filter,
      fulfillmentOptions,
      $timeout,
      $rootScope,
      uteModal,
      buyService,
      notifier,
      buyUtils,
      dtmService,
      dtmServiceConstants,
      cartManager,
      commonService,
      brtSwitchCMS
    ) {
      var $translate = $filter('translate');
      var _fulfillmentSelectedOption = '',
        _defaultPayload = {};

      $scope.serverResponse = {};

      $scope.isHybridFlow = brtSwitchCMS.brtSwitch.isHybridFlow;

      $scope.techInstall = {};
      $scope.shipToAddress = {};
      $scope.pickupAtStore = {};
      $scope.takeItWithYou = {};
      $scope.addNewClass = false;
      $scope.hasBeenSubmitted = false;

      $scope.fulfillmentTechInstallProps = {};
      $scope.fulfillmentTechInstallInOut = {};
      $scope.fulfillmentTechInstallMixins = {};

      $scope.fulfillmentTechInstallProps.state = {
        fetchOnload: true
      };
      $scope.fulfillmentTechInstallInOut.techInstall = $scope.techInstall;
      $scope.fulfillmentTechInstallInOut.forms = $scope.forms;
      $scope.fulfillmentTechInstallMixins.ruiMethods = $rootScope.ruiMethods;

      //FUSS-1518 - DTM tracking for fulfillment step 3
      var tierInCart = cartManager.internet.tierInCart();
      if (tierInCart) {
        if (tierInCart.selectedOffer && tierInCart.selectedOffer.offerPrice) {
          dtmService.setVar(dtmServiceConstants.dtmRules.buyInternet.selectedProduct, tierInCart.selectedOffer.offerId);
          dtmService.setVar(
            dtmServiceConstants.dtmRules.buyInternet.productPrice,
            tierInCart.selectedOffer.offerPrice.price
          );
        }
        dtmService.direct(dtmServiceConstants.dtmRules.buyInternet.installation.ruleName);

        /* DSO-15392 start */
        if ($rootScope.promoOfferId === null || $rootScope.discountOffers === null) {
          if (
            commonService.customerHasInternetService &&
            commonService.internetAccountStatus !== 'SUSPENDED' &&
            commonService.internetAccountStatus !== 'CANCELLED'
          ) {
          } else {
            var isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
            if (isOfferIdEligible === null) {
              buyService.getInternetPromos().then(function(data) {
                if (data) {
                  isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
                  $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                  $rootScope.discountOffers = buyService.getDiscountOffers();
                }
              });
            } else {
              $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
              $rootScope.discountOffers = buyService.getDiscountOffers();
            }
          }
        } else if (tierInCart && $rootScope.discountOffers === null && !$rootScope.ruiMethods.user.is.loggedIn()) {
          buyService.getInternetPromos().then(function(data) {
            $scope.discountOffers = data;
          });
        }
        /* DSO-15392 end */
      }

      var getSession = function(name) {
        var session;

        session = angular.fromJson(sessionStorage.getItem(name));
        return session;
      };

      // set tabs
      if ($rootScope.ruiMethods.user.is.agent()) {
        if (
          $rootScope.ruiMethods.agent.type() === 'UTEDEALER' ||
          $rootScope.ruiMethods.agent.type() === 'UTECORPORATE'
        ) {
          $scope.tabData = [
            {
              heading: 'retail.label.fulfillmentShipToAddress',
              route: 'shipToAddress',
              tracking: 'buyFulfillment:shiptoaddress'
            },
            {
              heading: 'global.label.takeItWithYou',
              route: 'takeItWithYou',
              tracking: ''
            } /*,
            {
              heading: 'global.label.fulfillmentTechInstall',
              route: 'techInstall',
              tracking: 'buyFulfillment:techinstall'
            }*/
          ];
          if (getSession('fulfillment').options.techInstall !== null) {
            $scope.tabData.push({
              heading: 'global.label.fulfillmentTechInstall',
              route: 'techInstall',
              tracking: 'buyFulfillment:techinstall'
            });
          }
        } else {
          $scope.tabData = [
            {
              heading: 'retail.label.fulfillmentShipToAddress',
              route: 'shipToAddress',
              tracking: 'buyFulfillment:shiptoaddress'
            }
            /*{
              heading: 'global.label.fulfillmentTechInstall',
              route: 'techInstall',
              tracking: 'buyFulfillment:techinstall'
            }*/
          ];
          if (getSession('fulfillment').options.techInstall !== null) {
            $scope.tabData.push({
              heading: 'global.label.fulfillmentTechInstall',
              route: 'techInstall',
              tracking: 'buyFulfillment:techinstall'
            });
          }
        }
      } else {
        $scope.tabData = [
          {
            heading: 'global.label.fulfillmentShipToAddress',
            route: 'shipToAddress',
            tracking: 'buyFulfillment:shiptoaddress'
          },
          {
            heading: 'global.label.fulfillmentPickUpAtStore',
            route: 'pickupAtStore',
            tracking: 'buyFulfillment:pickupatstore'
          } /*
          {
            heading: 'global.label.fulfillmentTechInstall',
            route: 'techInstall',
            tracking: 'buyFulfillment:techinstall'
          }*/
        ];
        //console.log("===>", getSession('fulfillment'));
        if (getSession('fulfillment').options.techInstall !== null) {
          $scope.tabData.push({
            heading: 'global.label.fulfillmentTechInstall',
            route: 'techInstall',
            tracking: 'buyFulfillment:techinstall'
          });
        }
      }

      // set type of fulfillment options base on response from server
      $scope.setFulfillmentOptions = function() {
        // returns `1 if techInstall or `3 if three-tabbed fulfillment options
        // return _.keys(_.pick(fulfillmentOptions.options, _.isString)).length;
        return buyService.getFulfillmentType();
      };

      $scope.fulfillmentRules = {
        phone: {
          pattern:
            '(^\\d{3}\\d{3}\\d{4}$)|(^\\d{3}\\s\\d{3}\\s\\d{4}$)|(^\\d{3}\\.\\d{3}\\.\\d{4}$)|(^\\d{3}-\\d{3}-\\d{4}$)'
        },
        instructions: { required: 'false' },
        shippingAddressOption: {},
        anotherAddress: {},
        address: {},
        agree: {}
      };

      // TODO deprecate! triple check reference
      // $scope.today = fulfillmentOptions.date;

      $scope.fulfillment = {
        agree: false,
        loading: false
      };

      // tech install methods and vars
      $scope.timeSlots = {};
      $scope.dayHeader = [];

      $scope.resetScope = function() {
        var currentState = buyService.getFulfillmentType() > 1 ? $state.current.name : 'techInstall';
        console.log('@fulfillment:resetScope() ', $scope.forms.fulfillment.options[$state.current.name], currentState);

        if ($scope.forms.review.isTouched && $scope.forms.fulfillment.options.techInstall.slot) {
          // empty slot in scope
          $scope.forms.fulfillment.options.techInstall.slot = {};
        }

        $timeout(function() {
          console.log('--$TIMEOUT EXTENDING CURRENT STATE ON NEXT TICK: ($scope) ', $scope, fulfillmentOptions);
          angular.extend($scope[currentState], $scope.forms.fulfillment.options[currentState]);
          angular.extend($scope[currentState], { selectedDate: fulfillmentOptions.currentDate }); // TODO TBD

          // handle prepulating phone field
          if ($scope.forms.fulfillment.__completed && $scope.forms.fulfillment.options.techInstall.phone) {
            /*
             * @if
             * coming back to techinstall step from other step
             * if there is a phone value saved from previous submission
             * use it and render ui with the value
             */
            $scope[currentState].phone = +$scope.forms.fulfillment.options.techInstall.phone;
            console.log('@resetScope:IF', $scope[currentState]);
          } else if (!$scope.forms.fulfillment.__completed) {
            /*
             * @elseif
             * landing to techinstall step for the first time
             * get the phone value from first step and render ui with it
             *
             */
            $scope[currentState].phone = +$scope.forms.createUser.phone;
            console.log('@resetScope:ELSEIF', $scope[currentState]);
          } else if (
            $scope.forms.fulfillment.__completed &&
            angular.isUndefined($scope.forms.fulfillment.options.techInstall.phone)
          ) {
            /*
             * @elseif
             * coming back to techinstall tab from other step
             * if phone property is not defined in cached fulfillment.options.techInstall Object
             * prepopulate the phone field with the phone entered from first step
             */
            $scope[currentState].phone = +$scope.forms.createUser.phone;
          } else if (
            $scope.forms.fulfillment.__completed &&
            $scope.forms.fulfillment.options.techInstall.phone === null
          ) {
            /*
             * @elseif
             * when cached phone property value is null in fulfillment.options.techInstall.phone
             * – user has decided to clear the phone upon submitting via tech-install
             * – coming back to tech-install tab from other step, in this case, show an empty field
             */
            $scope[currentState].phone = '';
          }

          // console.log('@resetScope $scope[$state.current.name] ', $scope[currentState], $scope.forms.fulfillment.options[currentState]);

          $scope.buyMethods.initFormsScope();
          $scope.$broadcast('Events:Fulfillment:ResetScope');
        });
      };

      var _anotherShippingAddress = {};

      $scope.fulfillmentMethods = {
        setShippingAddress: function(addressObj) {
          _anotherShippingAddress = addressObj;
        }
      };
      $scope.toggleSubmittedValue = function() {
        $scope.hasBeenSubmitted = false;
      };

      $scope.confirmFulfillmentOptions = function(formName) {
        $scope.addNewClass = true;
        $scope.hasBeenSubmitted = true;
        //DSO-12647 scroll to the first error
        $timeout(function() {
          var errorList = document.getElementsByClassName('ute-message error ng-active');
          if (errorList.length > 0) {
            var iElement = 0;
            while (errorList[iElement].getClientRects().length <= 0 && errorList.length > iElement) {
              iElement++;
            }
            if (errorList[iElement] && errorList[iElement].getClientRects().length > 0) {
              var yPos = errorList[iElement].getClientRects()[0].top;
              var scrollValue =
                yPos -
                document.getElementsByClassName('create-profile-menu-holder')[0].offsetHeight -
                document.getElementById('header').offsetHeight -
                95;
              window.scrollBy(0, scrollValue);
            }
          }
        });
        _fulfillmentSelectedOption = $state.current.name;
        _defaultPayload = {};

        // prevent submitting if phone number is cleared
        if (buyService.getFulfillmentType() > 1) {
          if (_fulfillmentSelectedOption === 'techInstall' && $scope.techInstall && !$scope.techInstall.phone) return;
        } else if (buyService.getFulfillmentType() === 1) {
          if (_fulfillmentSelectedOption === 'fulfillment' && $scope.techInstall && !$scope.techInstall.phone) return;
        }

        // set child form submitted
        // name of form depends on the route name
        if (formName[_fulfillmentSelectedOption + 'Form'] || $scope[_fulfillmentSelectedOption + 'Form']) {
          // let ng handle error validations
          formName[_fulfillmentSelectedOption + 'Form'].$setSubmitted();

          // if ($scope[_fulfillmentSelectedOption + 'Form'] && $scope[_fulfillmentSelectedOption + 'Form'].$invalid) return;
          // if (formName[_fulfillmentSelectedOption + 'Form'] && formName[_fulfillmentSelectedOption + 'Form'].$invalid) return;
          if (
            formName[_fulfillmentSelectedOption + 'Form'] &&
            formName.takeItWithYouForm &&
            formName.takeItWithYouForm.$invalid
          )
            return;
        }

        $scope.forms.fulfillment.selectedOption = _fulfillmentSelectedOption;

        switch ($state.current.name) {
          case 'shipToAddress':
            var _cAddress;

            if (!$scope.fulfillment.agree && buyService.getCableCondition() === 'Cold') {
              // prevent submit if user haven't agreed
              return;
            } else {
              var updateSessionAndSubmitFulfillment = function() {
                // when address is mailable
                // add the address object into the local scope to be cached
                angular.extend($scope[_fulfillmentSelectedOption], {
                  address: _anotherShippingAddress
                });

                console.log(
                  '@confirmFulfillmentOptions:case shipToAddress:anotherAddress ',
                  $scope[_fulfillmentSelectedOption],
                  _anotherShippingAddress
                );

                // prepare data to save to session
                prepDataToCache();

                // set request data

                // set service address
                angular.forEach($scope.forms.createUser.data.serviceAddress, function(v, k) {
                  if (v) {
                    _defaultPayload['a' + _.capitalize(k)] = v;
                  }
                });

                // set another another address
                angular.forEach(_anotherShippingAddress, function(v, k) {
                  if (v) {
                    _defaultPayload['b' + _.capitalize(k)] = v;
                  }
                });

                // set selected-option depending on fulfillment-type
                angular.extend(_defaultPayload, {
                  isServiceAddAsShipping: $scope[_fulfillmentSelectedOption].shippingAddressOption === 'serviceAddress'
                });

                submitFulfillment();
              };
              // handle address validation if user chooses another address
              if ($scope[_fulfillmentSelectedOption].shippingAddressOption === 'anotherAddress') {
                console.log(
                  '@buyFulfillmentCtrl:confirmFulfillmentOptions:case shipToAddress (_anotherShippingAddress, forms.fulfillment), ',
                  _anotherShippingAddress,
                  $scope.forms.fulfillment
                );
                // TODO
                // HANDLE EDIT AND SUBMITTING WITHOUT CHANGING ADDRESS

                if (!$scope.forms.fulfillment.__completed) {
                  // handle init case
                  if (_.isEmpty(_anotherShippingAddress)) return;
                } else {
                  // handle edit case
                  if (
                    $scope.forms &&
                    $scope.forms.fulfillment &&
                    $scope.forms.fulfillment.options &&
                    $scope.forms.fulfillment.options.shipToAddress &&
                    $scope.forms.fulfillment.options.shipToAddress.address
                  ) {
                    _cAddress = angular.copy($scope.forms.fulfillment.options.shipToAddress.address);
                  }

                  console.log('+++U ', _anotherShippingAddress, _cAddress);

                  if (_.isEmpty(_anotherShippingAddress) && _cAddress) {
                    // handle edit without change
                    angular.extend(_anotherShippingAddress, _cAddress);
                  } else {
                  }
                }
                if (!brtSwitchCMS.brtSwitch.isHybridFlow && !$rootScope.ruiMethods.user.is.agent()) {
                  // check if address is mailable
                  buyService.searchAddress(_anotherShippingAddress, 'shipping').then(
                    function(res) {
                      updateSessionAndSubmitFulfillment();
                    },
                    function(res) {
                      console.log('@fulfillment:searchAddress:reject ', res);

                      if (!res.addressExisting) {
                        _satellite.setVar('error', 'FHSI | fulfillment:searchAddress:reject');
                        _satellite.track('bfa-fhsi-error');
                        console.log('set address invalid ', $scope);

                        formName.shipToAddressForm.$setSubmitted();
                        formName.shipToAddressForm.anotherAddress.$setValidity('required', res.addressExisting);
                      }
                    }
                  );
                } else {
                  updateSessionAndSubmitFulfillment();
                }
              } else {
                console.log('@buyFulfillmentCtrl:confirmFulfillmentOptions:case shipToAddress --ELSE ');

                // handle regular flow proceeding with service address

                // set data to cache
                prepDataToCache();

                // set request data

                // set service address
                angular.forEach($scope.forms.createUser.data.serviceAddress, function(v, k) {
                  if (v) {
                    _defaultPayload['a' + _.capitalize(k)] = v;
                  }
                });

                // set another another address
                angular.forEach($scope.forms.createUser.data.serviceAddress, function(v, k) {
                  if (v) {
                    _defaultPayload['b' + _.capitalize(k)] = v;
                  }
                });

                // set selected-option depending on selected-fulfillment-type
                angular.extend(_defaultPayload, {
                  isServiceAddAsShipping: $scope[_fulfillmentSelectedOption].shippingAddressOption === 'serviceAddress'
                });

                // trigger submit
                submitFulfillment();
              }
            } // end else
            break;
          case 'pickupAtStore':
            // agree=false -> do not proceed
            if (!$scope.fulfillment.agree) {
              return;
            } else {
              // user haven't chosen a store and triggered a submit
              // if (!$scope[_fulfillmentSelectedOption].selectedPosition) {

              //   uteModal.open({
              //     title: $translate('global.label.selectStore'),
              //     message: $translate('global.message.selectStore'),
              //     okButtonLabel: $translate('global.cta.okay')
              //   });
              //   return;
              // }

              // set data to cache
              prepDataToCache();

              // set selected-option depending on the selected-fulfillment-type
              // angular.extend(_defaultPayload, {selectedFulfillmentOption: fulfillmentOptions.options[_fulfillmentSelectedOption]});

              console.log(
                '@fulfillment:confirmFulfillmentOptions:PICKUPATSTORE (_defaultPayload, fulfillmentOptions.options, fulfillmentOptions)',
                _defaultPayload,
                fulfillmentOptions.options[_fulfillmentSelectedOption],
                fulfillmentOptions
              );

              // trigger submit
              submitFulfillment();
            }
            break;
          case 'fulfillment':
            _fulfillmentSelectedOption = 'techInstall';
          case 'techInstall':
            // when user triggered a submit without choosing a time-slot -> notify user to choose one
            console.log('@confirmFulfillmentOptions:case techInstall: ', $scope[_fulfillmentSelectedOption]);
            if (
              angular.isUndefined($scope[_fulfillmentSelectedOption].slot) ||
              _.isEmpty($scope[_fulfillmentSelectedOption].slot)
            ) {
              uteModal.open({
                title: $translate('global.label.selectTimeSlot'),
                message: $translate('global.message.selectTimeSlot'),
                okButtonLabel: $translate('global.cta.okay'),
                cancelButtonLabel: ''
              });
              return;
            }

            var _timeSlots = buyService.getSession('fulfillment').timeSlots;

            console.log('@buyFulfillmentCtrl: ($scope.timeSlots) ', $scope.timeSlots);

            // find full slot object depending on the selected slotIndex then extend _defaultPayload with it
            _.findKey(_timeSlots, function(slots) {
              _.each(slots, function(slot) {
                console.log(
                  '@confirmFulfillmentOptions:case techInstall: find slot index ',
                  slot.slotIndex === $scope[_fulfillmentSelectedOption].slotIndex
                );
                if (slot.slotIndex === $scope[_fulfillmentSelectedOption].slot.slotIndex) {
                  angular.extend($scope[_fulfillmentSelectedOption], { slot: slot });
                  angular.extend(_defaultPayload, slot);
                  angular.extend(_defaultPayload, { techInstallDate: slot.startTime });

                  console.log(
                    '@confirmFulfillmentOptions:case techInstall: found slot ',
                    $scope.forms.fulfillment.options,
                    slot
                  );
                }
              });
            });

            // set data to cache
            prepDataToCache();

            angular.extend(_defaultPayload, {
              specialInstructions: $scope[_fulfillmentSelectedOption].instructions,
              contactNumber: buyUtils.formatPhoneNumber($scope[_fulfillmentSelectedOption].phone)
            });

            // set selected-option depending on the selected-fulfillment-type

            if (buyService.getFulfillmentType() === 1) {
              angular.extend(_defaultPayload, { selectedFulfillmentOption: fulfillmentOptions.options.techInstall });
            }
            // else {
            //   angular.extend(_defaultPayload, {selectedFulfillmentOption: fulfillmentOptions.options[_fulfillmentSelectedOption]});
            // }

            // trigger submit
            submitFulfillment();
            break;
          case 'takeItWithYou':
            prepDataToCache();

            if ($scope.serviceAddress.cableCondition === 'Cold') {
              angular.extend(_defaultPayload, {
                specialInstruction: $scope[_fulfillmentSelectedOption].techInstruction,
                equipmentSerial: $scope[_fulfillmentSelectedOption].modemSerialNumber
              });
            } else {
              angular.extend(_defaultPayload, {
                equipmentSerial: $scope[_fulfillmentSelectedOption].modemSerialNumber
              });
            }

            submitFulfillment(formName);
            break;
          default:
        }
      }; // confirmFulfillmentOptions()

      // if cable-condition is Unwired -> render time slots from response data
      // which will result to tech-install only fulfillment-option
      if (buyService.getFulfillmentType() === 1) {
        $scope.resetScope();
      }

      function prepDataToCache() {
        console.log(
          '@prepDataToCache ($scope.' + _fulfillmentSelectedOption + ') ',
          $scope[_fulfillmentSelectedOption]
        );

        $scope.forms.fulfillment.options[_fulfillmentSelectedOption] = $scope[_fulfillmentSelectedOption];

        if (buyService.getFulfillmentType() === 1 && _fulfillmentSelectedOption === 'fulfillment') {
          _fulfillmentSelectedOption = 'techInstall';
        }

        $scope.forms.fulfillment.options[_fulfillmentSelectedOption].phone = $scope.forms.fulfillment.options[
          _fulfillmentSelectedOption
        ].phone
          ? buyUtils.formatPhoneNumber($scope.forms.fulfillment.options[_fulfillmentSelectedOption].phone)
          : '';

        $scope.forms.fulfillment.selectedOption = _fulfillmentSelectedOption;
        console.log('@prepDataToCache ', $scope.forms.fulfillment);
      }

      function submitFulfillment(formName) {
        console.log('@submitFulfillment: SUBMITTING WITH: ', _defaultPayload);

        if ($rootScope.ruiMethods.user.is.agent() && brtSwitchCMS.brtSwitch.isHybridFlow) {
          buyService.setCheckoutMode(false);
          $scope.completedForm('fulfillment');
        } else {
          buyService.submitfulfillmentOptions(_defaultPayload).then(
            function(res) {
              var reqData = {};
              reqData.billingArrangementId = $scope.forms.paymentOptions.data.billingArrangementId;

              console.log('@buyFulfillmentCtrl:submitFulfillment ($scope.forms)', $scope.forms);

              if ($scope.forms.review.isTouched) {
                console.log(
                  '@buyFulfillmentCtrl:submitFulfillment:IF FO & PO COMPLETED; ($scope.forms) ',
                  $scope.forms
                );

                /*
                 * @if
                 * handle: edit package scenario
                 * call /getOrderSummary after submitfulfillmentOptions to update cache
                 *
                 */

                buyService.getOrderSummary(reqData).then(
                  function(orderRes) {
                    angular.extend($scope.forms.review.data, orderRes);
                    buyService.setCheckoutMode(false);
                    $scope.completedForm('fulfillment');
                  },
                  function(orderErrRes) {}
                );
              } else {
                console.log('@buyFulfillmentCtrl:submitFulfillment:ELSE NORMAL FLOW; ($scope.forms) ', $scope.forms);

                // handle normal flow
                buyService.setCheckoutMode(false);
                $scope.completedForm('fulfillment');
              }
            },
            function(submitFulfillmentErr) {
              if ($state.current.name === 'takeItWithYou' && formName[$state.current.name + 'Form']) {
                if (submitFulfillmentErr.error === '60000') {
                  _satellite.setVar('error', 'FHSI | submitFulfillmentErr failed');
                  _satellite.track('bfa-fhsi-error');
                  $scope.serverResponse.invalidSerial = true;
                  formName[$state.current.name + 'Form'].modemSerialNumber.$setDirty();
                  formName[$state.current.name + 'Form'].modemSerialNumber.$setValidity('required', false);
                } else if (submitFulfillmentErr.error === '60001') {
                  _satellite.setVar('error', 'FHSI | submitFulfillmentErr failed');
                  _satellite.track('bfa-fhsi-error');
                  $scope.serverResponse.usedSerial = true;
                  formName[$state.current.name + 'Form'].modemSerialNumber.$setDirty();
                  formName[$state.current.name + 'Form'].modemSerialNumber.$setValidity('existingSerialError', false);
                }
              }
            }
          );
        }
      }

      $scope.resetInput = function(form, input) {
        form[input].$setValidity('existingSerialError', true);
        _satellite.setVar('error', 'FHSI | submitFulfillmentErr failed');
        _satellite.track('bfa-fhsi-error');
        $scope.serverResponse = {};
      };

      $scope.getTime = function(slotsRow, duration) {
        if (angular.isArray(slotsRow)) {
          return _.result(
            _.find(slotsRow, function(slot) {
              return slot.slotIndex !== -1;
            }),
            duration
          );
        }
      };

      $scope.$on('$stateChangeStart', function(evt, toState, toParams, fromState, fromParams) {
        console.log('----STATE CHANGE START IN FULFILLMENT (fromState, toState) ', fromState, toState);
      });
      $scope.$on('$stateChangeSuccess', function(evt, toState, toParams, fromState, fromParams) {
        console.log('----STATE CHANGE SUCCESS IN FULFILLMENT (fromState, toState) ', fromState, toState);

        if (
          (fromState.url === '^' && buyService.getFulfillmentType() === 1) ||
          (fromState.name === 'review' && buyService.getFulfillmentType() === 1) ||
          (fromState.name === 'paymentOptions' && buyService.getFulfillmentType() === 1)
        ) {
          // handle refresh
          console.log('----STATE CHANGE SUCCESS handle refresh on tconly & edit (from review)');

          $scope.fulfillmentTechInstallProps.state.fetchOnload = true;
        } else if ((fromState.name === 'creditCheck', buyService.getFulfillmentType() === 1)) {
          // handle normal from from creditCheck -> fulfillment
          $scope.fulfillmentTechInstallProps.state.fetchOnload = false;
        } else if (fromState.name === 'shipToAddress' && toState.name === 'techInstall') {
          console.log('@buyFulfillmentCtrl:$stateChangeSuccess ELSEIF (fromState.name == shipToAddress) ', fromState);

          $scope.fulfillmentTechInstallProps.state.fetchOnload = true;
        }
      });

      $scope.$on('$includeContentLoaded', function() {
        console.log('@buyFulfillmentCtrl $includeContentLoaded', arguments);
      });
    }
  ]);
})();
